import cardGrid from '../../styles/card-grid.module.css';
import SpecialCard, { CardRenderableSpecial } from './card';

interface Props {
  specials: (CardRenderableSpecial & { id: string | number })[];
  showMonth?: boolean;
}

const SpecialCardGrid: React.FC<Props> = ({ specials, showMonth }) => (
  <div className={cardGrid.cardGrid}>
    {specials.map(special => (
      <SpecialCard special={special} key={special.id} showMonth={showMonth} />
    ))}
  </div>
);

export default SpecialCardGrid;
